import styled from '@emotion/styled';
import { colors } from '@theme/colorsCustomer';
import { fonts } from '@theme/fontsCustomer';

export const FormLabel = styled.span<{ width?: string }>`
  ${fonts.Headline8}
  color: ${colors.light['text-gray-main']};
  width: ${({ width }) => width ?? 'auto'};
`;
